import React, { useRef, useEffect, useCallback, useState } from 'react'
import { Row, Col, Button } from 'antd'
import { CloudUploadOutlined } from '@ant-design/icons'
import { FinishedView } from 'views/Finished'
import { Back } from 'components/BuildSteps/Back'
import { useKaraoke } from 'hooks/karaoke'
import {
  useTimelineEvents,
  TIMELINE_ACTIONS,
  useEventsPlayer,
} from 'hooks/TimelineEvents'
import { forEach, ceil } from 'lodash'
import { ButtonContainer } from 'components/Button'
import { NotificationEmailButton } from 'forms/NotificationEmail/modal'
import { useEventDispatch, _EVENTS } from 'utils/EventEmitter'

const UploadButton = ({ disabled, onClick }) => (
  <Button type='primary' disabled={disabled} onClick={onClick}>
    Upload
    <CloudUploadOutlined />
  </Button>
)

export const FinishedPhase = (props) => {
  const { audio, startUploadStep } = useKaraoke()
  const {getTimelineEvents} = useTimelineEvents()

  const audioRef = useRef()
  const {play} = useEventsPlayer({audioRef})

  const handleSubmit = useCallback(({ videoFormat, ...metadata }) => {
    startUploadStep(getTimelineEvents(), metadata)
  }, [])

  useEffect(() => {
    setTimeout(play, 500)
  }, [])


  return (
    <>
      <FinishedView />

      <Row className='footer'>
        <Col>
          <ButtonContainer>
            <Back />
          </ButtonContainer>
        </Col>
        <Col flex={1}>
          <audio
            controls
            className='form-audio'
            src={audio.src}
            ref={audioRef}
          />
        </Col>
        <Col>
          <ButtonContainer>
            <NotificationEmailButton
              onSuccess={handleSubmit}
              button={UploadButton}
            />
          </ButtonContainer>
        </Col>
      </Row>
    </>
  )
}
